import React from "react"
import { ShieldOff } from "lucide-react"

export function NoAccess({ message = "You don't have permission to view this page." }) {
  return (
    <div className="flex flex-col items-center justify-center py-24 text-center">
      <div className="mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-slate-100">
        <ShieldOff className="h-6 w-6 text-slate-400" />
      </div>
      <h2 className="text-[18px] font-bold text-slate-900">Access Restricted</h2>
      <p className="mt-2 max-w-sm text-[14px] text-slate-500">{message}</p>
    </div>
  )
}
